"use strict";
import moment from 'moment';
function momentDateAndTime(date) {
    return date ? moment(date).format('lll') : moment().format('lll')
};

export default momentDateAndTime;